import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "fas fa-medium-size fa-star text-warning"
}
const _hoisted_3 = {
  key: 1,
  class: "fas fa-medium-size fa-star text-primary25"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StarRating',
  props: {
    ratingCount: { default: 0 }
  },
  emits: ["onRatingChanged"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const ratingChanged = (rating: number) => emit("onRatingChanged", rating + 1);

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(5).fill(''), (rating, index) => {
    return (_openBlock(), _createElementBlock("span", {
      key: 'rating-' + index,
      class: "me-2",
      onClick: ($event: any) => (ratingChanged(index))
    }, [
      (index + 1 <= __props.ratingCount)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2))
        : (_openBlock(), _createElementBlock("span", _hoisted_3))
    ], 8, _hoisted_1))
  }), 128))
}
}

})